import { useQuery } from "react-query";
import inventoryClient from "../clients/inventoryClient";

function useExistingOrders(establishmentId, page) {
    const queryReturnValues = useQuery(
        ["existing-orders", { establishmentId, page }],
        inventoryClient.getExistingOrders,
        {refetchOnWindowFocus: false}
    );

   return queryReturnValues;
}

export default useExistingOrders;